import React from "react";
import {
  HomeOutlined, DashboardOutlined, MenuOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
  SearchOutlined, FilterOutlined, SettingOutlined, ControlOutlined,
  PlusOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, CloseOutlined,
  CloseCircleOutlined, CloseCircleFilled, CheckOutlined, CheckCircleOutlined,
  CheckCircleFilled, CheckSquareOutlined,
  ArrowUpOutlined, ArrowDownOutlined, ArrowLeftOutlined, ArrowRightOutlined,
  CaretRightOutlined, CaretDownOutlined,
  FileOutlined, FileTextOutlined, FilePdfOutlined, FileWordOutlined, FileExcelOutlined,
  FilePptOutlined, FileSearchOutlined, FolderOutlined, FolderOpenOutlined,
  FileMarkdownOutlined,
  DownloadOutlined, CloudUploadOutlined,
  UserOutlined, UserSwitchOutlined,
  LockOutlined, KeyOutlined, SafetyOutlined, SafetyCertificateOutlined,
  BankOutlined, ApartmentOutlined, AppstoreOutlined, ProjectOutlined,
  ProfileOutlined, SnippetsOutlined,
  RobotOutlined, MessageOutlined, CommentOutlined, BellOutlined,
  MailOutlined, SendOutlined, NotificationOutlined, QuestionCircleOutlined,
  PlayCircleOutlined, PauseCircleOutlined, StopOutlined, VideoCameraOutlined,
  CustomerServiceOutlined,
  ClockCircleOutlined, HistoryOutlined, ReloadOutlined, SyncOutlined,
  LoadingOutlined, AlertOutlined, WarningOutlined, InfoCircleOutlined,
  BarChartOutlined, DatabaseOutlined, ApiOutlined, ContainerOutlined, ClusterOutlined,
  EyeOutlined, SaveOutlined, ExportOutlined,
  LinkOutlined, GlobalOutlined, HeartOutlined, BulbOutlined, ToolOutlined,
  TagOutlined, BookOutlined, ReadOutlined,
  RocketOutlined, ThunderboltOutlined, StarOutlined,
  PhoneOutlined, EnvironmentOutlined, BranchesOutlined, NodeIndexOutlined,
  PicCenterOutlined, FundOutlined, AppstoreAddOutlined, BarsOutlined,
  TranslationOutlined, LoginOutlined, LogoutOutlined, DragOutlined,
  RadarChartOutlined, ScanOutlined,
} from "@ant-design/icons";

const MAP: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  "home-line": HomeOutlined, "home-4-line": HomeOutlined,
  "dashboard-line": DashboardOutlined,
  "menu-line": MenuOutlined, "menu-2-line": MenuOutlined,
  "menu-fold-line": MenuFoldOutlined, "menu-unfold-line": MenuUnfoldOutlined,
  "search-line": SearchOutlined, "filter-3-line": FilterOutlined,
  "settings-3-line": SettingOutlined, "settings-4-line": ControlOutlined,
  "add-line": PlusOutlined, "add-circle-line": PlusCircleOutlined,
  "edit-line": EditOutlined, "delete-bin-line": DeleteOutlined,
  "close-line": CloseOutlined, "close-circle-line": CloseCircleOutlined, "close-circle-fill": CloseCircleFilled,
  "check-line": CheckOutlined, "check-circle-line": CheckCircleOutlined, "check-double-line": CheckSquareOutlined,
  "checkbox-blank-circle-line": CheckSquareOutlined, "checkbox-circle-line": CheckCircleOutlined, "checkbox-circle-fill": CheckCircleFilled,
  "arrow-up-line": ArrowUpOutlined, "arrow-down-line": ArrowDownOutlined,
  "arrow-left-line": ArrowLeftOutlined, "arrow-right-line": ArrowRightOutlined,
  "arrow-right-s-line": CaretRightOutlined, "arrow-down-s-line": CaretDownOutlined,
  "arrow-up-down-line": ArrowUpOutlined, "corner-down-right-line": CaretRightOutlined,
  "file-line": FileOutlined, "file-text-line": FileTextOutlined,
  "file-pdf-line": FilePdfOutlined, "file-word-line": FileWordOutlined,
  "file-excel-line": FileExcelOutlined, "file-ppt-line": FilePptOutlined, "file-ppt-2-line": FilePptOutlined,
  "file-list-line": ProfileOutlined, "file-list-3-line": ProfileOutlined,
  "file-search-line": FileSearchOutlined, "file-reduce-line": SnippetsOutlined,
  "file-chart-line": FundOutlined,
  "folder-line": FolderOutlined, "folder-open-line": FolderOpenOutlined,
  "folder-3-line": FolderOutlined, "folder-chart-line": FolderOutlined,
  "sticky-note-line": FileMarkdownOutlined,
  "article-line": ReadOutlined, "book-open-line": BookOutlined,
  "upload-cloud-line": CloudUploadOutlined, "upload-cloud-2-line": CloudUploadOutlined,
  "download-2-line": DownloadOutlined, "external-link-line": ExportOutlined,
  "user-line": UserOutlined, "user-settings-line": UserSwitchOutlined,
  "shield-line": SafetyOutlined, "shield-check-line": SafetyCertificateOutlined,
  "shield-user-line": SafetyOutlined, "shield-keyhole-line": SafetyCertificateOutlined,
  "lock-line": LockOutlined, "lock-2-line": LockOutlined, "lock-password-line": LockOutlined,
  "key-line": KeyOutlined, "key-2-line": KeyOutlined,
  "login-box-line": LoginOutlined, "logout-box-line": LogoutOutlined,
  "building-line": BankOutlined, "building-2-line": BankOutlined,
  "briefcase-line": ContainerOutlined, "stack-line": AppstoreOutlined,
  "kanban-view-line": ProjectOutlined,
  "layout-grid-line": AppstoreAddOutlined, "layout-masonry-line": BarsOutlined,
  "price-tag-3-line": TagOutlined,
  "brain-line": RobotOutlined, "chat-3-line": MessageOutlined,
  "chat-ai-line": CommentOutlined, "chat-check-line": CommentOutlined,
  "question-answer-line": QuestionCircleOutlined, "question-line": QuestionCircleOutlined,
  "sparkling-line": StarOutlined, "lightbulb-line": BulbOutlined,
  "play-line": PlayCircleOutlined, "play-circle-line": PlayCircleOutlined,
  "pause-circle-line": PauseCircleOutlined, "stop-fill": StopOutlined,
  "video-line": VideoCameraOutlined, "customer-service-2-line": CustomerServiceOutlined,
  "send-plane-line": SendOutlined, "send-plane-fill": SendOutlined,
  "time-line": ClockCircleOutlined, "timer-line": ClockCircleOutlined,
  "timer-flash-line": ThunderboltOutlined, "history-line": HistoryOutlined,
  "refresh-line": ReloadOutlined, "loader-4-line": LoadingOutlined,
  "progress-line": SyncOutlined, "alert-line": AlertOutlined,
  "error-warning-line": WarningOutlined, "information-line": InfoCircleOutlined,
  "calendar-line": ClockCircleOutlined,
  "bar-chart-line": BarChartOutlined, "bar-chart-box-line": BarChartOutlined,
  "database-2-line": DatabaseOutlined,
  "notification-3-line": NotificationOutlined, "notification-off-line": BellOutlined,
  "mail-line": MailOutlined, "mail-send-line": MailOutlined,
  "eye-line": EyeOutlined, "save-line": SaveOutlined,
  "tools-line": ToolOutlined, "rocket-line": RocketOutlined,
  "heart-pulse-line": HeartOutlined, "global-line": GlobalOutlined,
  "phone-line": PhoneOutlined, "map-pin-line": EnvironmentOutlined,
  "links-line": LinkOutlined, "git-branch-line": BranchesOutlined,
  "git-commit-line": NodeIndexOutlined, "node-tree": ApartmentOutlined,
  "translate-2-line": TranslationOutlined, "drag-move-line": DragOutlined,
  "radar-line": RadarChartOutlined, "scan-2-line": ScanOutlined,
  "radio-button-line": StarOutlined, "microscope-line": SearchOutlined,
  "mouse-line": EyeOutlined, "cpu-line": ClusterOutlined,
  "archive-line": ContainerOutlined, "slideshow-line": PicCenterOutlined,
  "route-line": NodeIndexOutlined, "rss-line": ApiOutlined,
};

const FALLBACK = AppstoreOutlined;

export interface RIconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
  size?: number | string;
}

export const RIcon: React.FC<RIconProps> = ({ name, className, style, color, size }) => {
  const key = name.replace(/^ri-/, "");
  const Comp = MAP[key] || FALLBACK;
  const merged: React.CSSProperties = {
    ...(color ? { color } : null),
    ...(size ? { fontSize: typeof size === "number" ? `${size}px` : size } : null),
    ...style,
  };
  return <Comp className={className} style={merged} />;
};

export default RIcon;
